export function getInterventionDescription(intervention) {
    return intervention?.description?.description ?? ''
}

function descriptionLead(intervention) {
    return getInterventionDescription(intervention).replace(/^\uFEFF/, '').trimStart()
}

export function isCheckIn(intervention) {
    return /^Check in\s*:/i.test(descriptionLead(intervention))
}

export function isCheckOut(intervention) {
    return /^Check out\s*:/i.test(descriptionLead(intervention))
}

export function isCheckInOrOut(intervention) {
    return isCheckIn(intervention) || isCheckOut(intervention)
}
